import {
  Box,
  Typography,
  Switch,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toggleAutoBalanceMode } from 'redux/slices';

export function AutoBalanceToggle() {
  const { autoBalanceMode } = useSelector((state) => state.game);
  const dispatch = useDispatch();

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Typography>Balanceamento automático</Typography>
      <Switch
        checked={autoBalanceMode}
        onChange={() => dispatch(toggleAutoBalanceMode())}
        size="small"
      />
    </Box>
  );
}
